import invariant from "tiny-invariant";

/**
 * Button Primary
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonPrimary = "#3576ba";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonPrimaryHover = "#005D95";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonPrimaryPressed = "#004173";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonPrimaryFocus = buttonPrimary;
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonPrimaryDisabled = "#b3ccea";

/**
 * Button Secondary
 */
// todo: rename to buttonSecondary to match color names in style guide.
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonDefault = "#eeeeee";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonDefaultHover = "#e0e0e0";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonDefaultPressed = "#c0c0c0";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonDefaultFocus = buttonDefault;
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonDefaultDisabled = "#f2f2f2";

/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonSecondary = "#32b1ad"; // todo: remove, obsolete.

/**
 * Button Share
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const ctaShare = "#007e84";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const ctaShareHover = "#40bac0";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const ctaShareActive = "#01595d"; // todo: rename to Pressed
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const ctaShareFocus = ctaShare;
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const ctaShareDisabled = "#aed5d6";

/**
 * Button Destructive
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonDestructive = "#cc2e3b";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonDestructiveHover = "#d8656f";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonDestructivePressed = "#a62833";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonDestructiveFocus = buttonDestructive;
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonDestructiveDisabled = "#edbec2";

/**
 * Button Upgrade
 */
// todo: replace existing ctaUpgrade with this set.
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonUpgrade = "#007a49";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonUpgradeHover = "#40c28f";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonUpgradePressed = "#00693f";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonUpgradeFocus = buttonUpgrade;
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const buttonUpgradeDisabled = "#b3d7c8";

/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const ctaUpgrade = "#2c6665";

/**
 * Link and Focus
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const ctaLink = "#0970be";

/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const focusDark = "#4c649d"; // focus dark 10 in figma
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const focus = "#6097d2";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const focusLight = "#b0cae9"; // todo: remove, obsolete?
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const focusLight10 = "#b3ccea"; // focus light 10 in figma
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const focusLight20 = "#c5d7ed"; // focus light 20 in figma

/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const active = "#204a76"; // todo: remove, obsolete?
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const focusActiveLight = "#b0cae9";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const focusActiveDark = "#566ae3"; // visPurpleDark10

/**
 * Success
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const successDark30 = "#00462a";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const successDark20 = "#00693f";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const successDark10 = "#008c54";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const success = "#01af6a";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const successLight10 = "#40c28f";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const successLight20 = "#7dd4b1";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const successLight30 = "#bbe7d6";

/**
 * Warning
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const warningDark30 = "#664e18";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const warningDark20 = "#997525";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const warningDark10 = "#cc9c31";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const warning = "#ffc33e";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const warningLight10 = "#fdd16e";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const warningLight20 = "#fcde9b";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const warningLight30 = "#fbeccb";

/**
 * Danger
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const dangerDark30 = "#531419";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const dangerDark20 = "#7c1e26";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const dangerDark10 = "#a62833";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const danger = "#d03340";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const dangerLight10 = "#db656f";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const dangerLight20 = "#e4969c";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const dangerLight30 = "#efc8cb";

/**
 * Info
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const infoDark30 = "#3f4952";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const infoDark20 = "#5e6d7b";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const infoDark10 = "#7e92a4";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const info = "#9eb7ce";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const infoLight10 = "#b6c8da";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const infoLight20 = "#cbd8e3";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const infoLight30 = "#e3e9ef";

/**
 * Visualization Blue
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visBlueDark30 = "#002847";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visBlueDark20 = "#004173";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visBlueDark10 = "#007cc5";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visBlue = "#5996d6";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visBlueLight10 = "#a7c1e4";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visBlueLight20 = "#d8e4fa";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visBlueLight30 = "#f0f5fd";

/**
 * Visualization Green
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visGreenDark30 = "#193700";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visGreenDark20 = "#275600";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visGreenDark10 = "#488306";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visGreen = "#70a13c";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visGreenLight10 = "#b2c997";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visGreenLight20 = "#e1ebd6";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visGreenLight30 = "#f3f7ef";

/**
 * Visualization Orange
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visOrangeDark30 = "#492400";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visOrangeDark20 = "#653300";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visOrangeDark10 = "#ab6600";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visOrange = "#e18502";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visOrangeLight10 = "#ffb761";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visOrangeLight20 = "#fee3c0";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visOrangeLight30 = "#fff4e6";

/**
 * Visualization Yellow
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visYellowDark30 = "#3d2c00";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visYellowDark20 = "#5a4000";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visYellowDark10 = "#996f00";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visYellow = "#e6a907";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visYellowLight10 = "#f5cf6a";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visYellowLight20 = "#ffefc5";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visYellowLight30 = "#fff8e7";

/**
 * Visualization Red
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visRedDark30 = "#6d0800";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visRedDark20 = "#9d0c00";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visRedDark10 = "#d14424";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visRed = "#ee6f4c";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visRedLight10 = "#f6b09d";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visRedLight20 = "#ffe0d7";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visRedLight30 = "#fff3ef";

/**
 * Visualization Purple
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visPurpleDark30 = "#0c245b";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visPurpleDark20 = "#0c3491";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visPurpleDark10 = "#566ae3";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visPurple = "#848be9";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visPurpleLight10 = "#bab8f1";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visPurpleLight20 = "#e6e5fa";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visPurpleLight30 = "#f5f5fd";

/**
 * Visualization Berry
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visBerryDark30 = "#610e44";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visBerryDark20 = "#8b2066";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visBerryDark10 = "#b94d90";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visBerry = "#c76ca1";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visBerryLight10 = "#e5b8d1";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visBerryLight20 = "#f5e1ec";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visBerryLight30 = "#fbf3f8";

/**
 * Visualization Teal
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visTealDark30 = "#002923";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visTealDark20 = "#004e43";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visTealDark10 = "#008476";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visTeal = "#4eaa9b";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visTealLight10 = "#a1c9c2";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visTealLight20 = "#dceae7";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const visTealLight30 = "#f1f7f6";

/**
 * Neutrals
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const neutralDark40 = "#111111";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const neutralDark30 = "#444444";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const neutralDark20 = "#727272";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const neutralDark10 = "#979797";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const neutral = "#c0c0c0";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const neutralLight10 = "#e0e0e0";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const neutralLight20 = "#ebebeb";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const neutralLight30 = "#f2f2f2";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const neutralLight40 = "#ffffff";

// This is "accessible" against black (7:1) but not against white(2.9:1).
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const neutralAccessible = neutralDark10;

/**
 * Backgrounds
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const defaultBackground = "#f8f7f5"; // figma: light bg
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const tooltipBackground = "rgba(84, 84, 84, 1)"; // figma: tooltip gray
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const blanketBackground = "rgba(0, 0, 0, 0.1)"; // figma: light overlay
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const leftNavBackground = "#003059"; // figma: left nav

/**
 * Shadows
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const shadowMenu = "rgba(0, 0, 0, 0.16)";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const shadowModal = "rgba(0, 0, 0, 0.12)";
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export const shadowBorder = "rgba(0, 0, 0, 0.12)";

/**
 * Adapted from https://css-tricks.com/converting-color-spaces-in-javascript/
 * @param hexColor "#rrggbb"
 * @param alpha a transparency number between 0.0 - 1.0;
 */
/**
 * @deprecated Since version 5.0. Will be deleted in version 6.0. Use a semantic token via the `color` function from `smartsheet/design-tokens-react` instead.
 */
export function toRgba(hexColor: string, alpha: number) {
    if (process.env.NODE_ENV !== "production") {
        invariant(
            hexColor.length === 7,
            `You've passed an illegal argument to toRgba. It should be of the pattern #aaaaaa: "${hexColor}".`
        );
        invariant(
            alpha >= 0 && alpha <= 1,
            `You've passed an illegal alpha number to toRgba. It should be between 0 and 1, inclusive: ${alpha}.`
        );
    }

    const r = "0x" + hexColor[1] + hexColor[2];
    const g = "0x" + hexColor[3] + hexColor[4];
    const b = "0x" + hexColor[5] + hexColor[6];
    const a = +alpha.toFixed(3);

    return `rgba(${+r},${+g},${+b},${a})`;
}
